/**
 * Test IDs for QA automation.
 */
export const testIds = {
  forecastingDashboardPhone: "forecasting-dashboard-phone",
  forecastingDashboardEmail: "forecasting-dashboard-email",
} as const;
